<template>
  <v-footer
      color="black"
      padless
  >
    <v-row
        justify="center"
        no-gutters
    >
      <v-btn
          v-for="link in links"
          color="primary"
          text
          rounded
          class="my-2"
          :to="link.ref"
          :key="link.name"
      >
        {{ link.name }}
      </v-btn>

      <v-container class="pa-2 ma-0">
        <img style="width: 100%" id="logoOnNavbar" src="../assets/deutschDeluxeLogoTextBlue.png"/>
      </v-container>
      <v-col
          class="black py-4 text-center primary--text"
          cols="12"
      >
        {{ new Date().getFullYear() }} — <strong>© DeutschDeluxe</strong>
      </v-col>
    </v-row>
  </v-footer>
</template>

<script>
    export default {
        name: "Footer",
        data: () => ({
            links: [
                {name: 'Impressum', ref: 'imprint'},
                {name: 'AGBs', ref: 'agbs'},
                {name: 'Datenschutz', ref: 'dataprivacy'},
            ],
        }),
    }
</script>

<style scoped>

</style>
